import axios from 'axios'
import {BUSCAR_CONFIGURACAO_PONTO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarTodasAdesoesPontos() {
    const url = `${URL}/configuracao-ponto`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_CONFIGURACAO_PONTO,
            payload: response,

        }),
    );
}
